import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BaseTypography } from '../../../common';
import { checkIsMenuItemActive, PUserMenuItem } from './helpers';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  // @ts-ignore
  menuItem: () => ({
    display: 'grid',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '15px',
    cursor: 'pointer',
    color: '#364153',
    textDecoration: 'none',
    borderRadius: '4px',
    gap: '8px',
    [theme.breakpoints.down('md')]: {
      borderRadius: '0 !important',
      padding: '10px',
      // '&:first-child': {
      //   borderRadius: isActive ? '10px 0 0 10px !important' : '0 !important',
      // },
      // '&:last-child': {
      //   borderRadius: isActive ? '0 10px 10px 0 !important' : 0,
      // },
    },
  }),
  menuItem_active: {
    background: theme.palette.primary.contrastText,
    // borderRadius: '10px 0 0 10px',
    color: 'white !important',
    '& .white': {
      color: 'white',
    },
  },
  menuItem__label: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
  },
  menuItem__ico: {
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      height: '25px',
      width: '25px',
    },
  },
}));

export const DesktopMenuItem: React.FC<PUserMenuItem> = (props) => {
  const { item } = props;
  const location = useLocation();

  const isActive = checkIsMenuItemActive({
    currentPath: location.pathname,
    itemPath: item.path,
    basePath: item.basePath,
  });

  const classes = useStyles();
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <Link
      to={item.path}
      className={clsx(classes.menuItem, isActive && classes.menuItem_active)}
    >
      <div className={classes.menuItem__ico}>
        <item.ico white={isActive} />
      </div>
      <BaseTypography className={classes.menuItem__label}>
        {item.label}
      </BaseTypography>
    </Link>
  );
};
